module.exports = __webpack_public_path__ + "static/img/bg_bottom.ea8a9d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting809/images/bg_bottom.png
// module id = +XiB
// module chunks = 4